export default __webpack_public_path__ + "static/media/(39).b989f445.JPG";